module.exports = __webpack_public_path__ + "static/media/reviva_thumb.39aeb519.jpg";